import { Reveal } from "@/components/Reveal";

// Drafting-style section overline + heading.
export function SectionHeading({ overline, title, intro, align = "left", index, className = "" }) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}
      data-testid={index ? `section-heading-${index}` : undefined}
    >
      {overline && (
        <Reveal className="font-mono-tech text-xs sm:text-sm tracking-widest uppercase text-primary mb-4 flex items-center gap-3">
          <span className="inline-block w-8 h-px bg-primary" aria-hidden />
          {overline}
        </Reveal>
      )}
      <Reveal
        as="h2"
        delay={60}
        className="font-display uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[0.95] text-foreground"
      >
        {title}
      </Reveal>
      {intro && (
        <Reveal delay={120} className="mt-5 text-muted-foreground text-base sm:text-lg leading-relaxed">
          {intro}
        </Reveal>
      )}
    </div>
  );
}
